import React from 'react';
import type File from '../../../interfaces/File';

import useFormatTimestamp from '../../../hooks/useFormatTimestamp';
import { dateFromTicks } from '../../../utils/utils';

interface FilesTableDeletionDateCellProps {
  file: File;
}

const FilesTableDeletionDateCell: React.FC<FilesTableDeletionDateCellProps> = ({ file }) => {
  const formatTimestamp = useFormatTimestamp();

  return <span>{file.deletedAt ? formatTimestamp(dateFromTicks(file.deletedAt)) : '-'}</span>;
};

export default FilesTableDeletionDateCell;
